import { useState } from "react";
import { Trans } from "react-i18next";

import { Callout, Overlay2, Tag } from "@blueprintjs/core";

import { mefBrand, mefCountry, mefDate, mefPlate } from "../../../utils/mef";

export default function Detection(props) {
  const [zoom, setZoom] = useState(undefined);

  return (
    <Callout key={props.id} title={mefDate(props.date)}>
      <ul>
        <li>
          <Trans>sensor position</Trans>
          <Trans>:</Trans>
          <Trans>{"sensor_position" + props.sensor_position}</Trans>
        </li>
        {props.plate_color && (
          <li>
            <div className="flexbox-left">
              <Trans>plate color</Trans>
              <Trans>:</Trans>
              <div
                style={{
                  backgroundColor: props.vehicle_color.toLowerCase(),
                  height: "2ch",
                  width: "2ch",
                  border: "1px solid black",
                }}
              ></div>
              <Trans>{props.plate_color}</Trans>
            </div>
          </li>
        )}
        {props.vehicle_brand && (
          <li>
            <Trans>brand</Trans>
            <Trans>:</Trans>
            {mefBrand(props.vehicle_brand)}{" "}
            {props.vehicle_model && "(" + props.vehicle_model + ")"}
          </li>
        )}
        {props.vehicle_color && (
          <li>
            <div className="flexbox-left">
              <Trans>vehicle color</Trans>
              <Trans>:</Trans>
              <Tag
                style={{
                  backgroundColor: props.vehicle_color.toLowerCase()
                }}
              />
              <Trans>{props.vehicle_color}</Trans>
            </div>
          </li>
        )}
        {props.country && (
          <li>
            <Trans>country</Trans>
            <Trans>:</Trans>
            {mefCountry(props.country)}
          </li>
        )}
        {props.vehicle_class && (
          <li>
            <Trans>vehicle class</Trans>
            <Trans>:</Trans>
            <Trans>{props.vehicle_class?.label}</Trans>
          </li>
        )}
        <li>
          <Trans>plate</Trans>
          <Trans>:</Trans>
          {mefPlate(props.plate)}
        </li>
      </ul>

      {props.image && (
        <span>
          <Overlay2
            isOpen={zoom !== undefined}
            onClose={() => setZoom(undefined)}
            className="flexbox-center"
          >
            <img
              src={
                props.image.startsWith("data:image")
                  ? props.image
                  : "data:image/png;base64," + props.image
              }
              alt="capture"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
              }}
            />
          </Overlay2>
          {/* <Button onClick={() => setZoom(props.image)} icon="zoom-in" /> */}
          <img
            src={
              props.image.startsWith("data:image")
                ? props.image
                : "data:image/png;base64," + props.image
            }
            alt="capture"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              pointerEvents: "all",
            }}
            onClick={() => setZoom(props.image)}
          />
        </span>
      )}
    </Callout>
  );
}
